import React, { Component, createRef } from "react";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import _ from "lodash";
import { dominio } from "../../../routes_backend/routes.jsx";
import { Grid, Col, Row } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import Swal from "sweetalert2";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

const myGrid = React.createRef();
const TOTAL_FILAS = 9;
const FILAS_NORMAL = 6;
const FILAS_PRUEBA = 9;

const crearFilaVacia = () => ({
  FechaEnsayo: "",
  FechaRecepcion: "",
  Fecha: "",
  Boleta: "",
  Planta: "",
  Molde: "",
  Operador: "",
  UM: "",
  Producto: "",
  Produccion: "",
  OT: "",
  GrosorPared: "",
  EdadDias: "",
  PesoLb: "",
  KN: "",
  Ancho: "",
  Alto: "",
  Largo: "",
  U_KNKG: "",
  U_N1: "",
  U_N2: "",
  U_TipoFormula: "",
  ABruta: "",
  SBruta1: "",
  ResisProd: "",
  R1: "",
  SBruta2: "",
  SNeta2: "",
  R2: "",
  SBrutaProm: "",
  RProm: "",
});

const styles = {
  tableContainer: { overflowX: "auto", width: "100%" },
  table: { minWidth: "1200px", width: "max-content", borderCollapse: "collapse", fontSize: "13px" },
  th: { border: "1px solid #ddd", padding: "2px", backgroundColor: "#f2f2f2", textAlign: "center", whiteSpace: "nowrap" },
  td: { border: "1px solid #ddd", padding: "2px", textAlign: "center", whiteSpace: "nowrap" },
  tdMediano: { border: "1px solid #ddd", padding: "2px", textAlign: "center", whiteSpace: "nowrap", width: "80px" },
  tdMedianoOT: { border: "1px solid #ddd", padding: "2px", textAlign: "center", whiteSpace: "nowrap", width: "220px" },
  tdMedianoCombo: { border: "1px solid #ddd", padding: "3px", textAlign: "center", whiteSpace: "nowrap", width: "180px", height: "10px" },
  tdMedianoComboOP: { border: "1px solid #ddd", padding: "3px", textAlign: "center", whiteSpace: "nowrap", width: "280px", height: "10px" },
  input: { width: "100%", boxSizing: "border-box", padding: "4px", fontSize: "11px", marginBottom: "0px" },
  modalBackdrop: { position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050, display: "flex", justifyContent: "center", alignItems: "center", overflowY: "auto", padding: "1rem" },
  modalContent: { backgroundColor: "#fff", borderRadius: "5px", maxWidth: "900px", width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 5px 15px rgba(0,0,0,.5)" },
  modalHeader: { padding: "1rem", borderBottom: "1px solid #dee2e6", display: "flex", justifyContent: "space-between", alignItems: "center" },
  modalBody: { padding: "1rem" },
  modalFooter: { padding: "1rem", borderTop: "1px solid #dee2e6", textAlign: "right" },
  button: { cursor: "pointer", padding: "6px 12px", fontSize: "0.85rem", borderRadius: "3px", border: "1px solid #007bff", backgroundColor: "#007bff", color: "#fff" },
  rowSeparator: { borderBottom: "2px solid #00000070" },
  rowTopBorder: { borderTop: "2px solid #00000070" },
  rowBottomBorder: { borderBottom: "2px solid #00000070" },
  rowSideBorders: { borderLeft: "2px solid #00000070", borderRight: "2px solid #00000070" },
  centeredCell: { textAlign: "center", verticalAlign: "middle" },
};

class Calculo_Resistencias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moldesOptions: [],
      operadoresOptions: [],
      plantasOptions: [],
      productosOptions: [],
      mostrarCrear: true,
      mostrarEditar: false,
      otBusqueda: "",
      otEliminar: "",
      esPrueba: false,
      data: Array.from({ length: TOTAL_FILAS }, crearFilaVacia),
      isModalOpen: false,
      sourceGridCodigos: null,
      isLoading: false,
      selectedRowIndex: null,
      source_grid: "",
      otOriginal: "",
      otCount: 0,
      filtroFechaDesde: "",
      filtroFechaHasta: "",
      filtroPlanta: "",
      filtroProducto: "",
      columns: [
        { text: "F. Ensayo", datafield: "U_fechaEnsayo", width: "5%", cellsalign: "center" },
        { text: "F. Recepcion", datafield: "U_fechaRecepcion", width: "6%", cellsalign: "center" },
        { text: "F. Produccion", datafield: "U_fechaProduccion", width: "6%", cellsalign: "center" },
        { text: "Dias Edad", datafield: "U_diasEdad", width: "6%", cellsalign: "center" },
        { text: "#Boleta", datafield: "U_boleta", width: "5%", cellsalign: "center" },
        { text: "Planta", datafield: "U_planta", width: "5%", cellsalign: "center" },
        { text: "Molde", datafield: "U_molde", width: "8%", cellsalign: "center" },
        { text: "Operador", datafield: "U_operador", width: "15%", cellsalign: "center" },
        { text: "U/M", datafield: "U_um", width: "5%", cellsalign: "center" },
        { text: "Producto", datafield: "U_producto", width: "20%", cellsalign: "center" },
        { text: "Produccion", datafield: "U_produccion", width: "6%", cellsalign: "center" },
        {
          text: "OT", datafield: "U_ot", width: "12%", cellsalign: "center", editable: true,
          cellsrenderer: function (row, columnfield, value) {
            return '<div style="margin:4px; padding:4px; background-color:green; color:white; text-align:center; border-radius:4px;">' + value + "</div>";
          },
        },
        { text: "Grosor Pared", datafield: "U_grosorPared", width: "6%", cellsalign: "center" },
        { text: "Peso", datafield: "U_peso", width: "5%", cellsalign: "center" },
        { text: "KN", datafield: "U_kn", width: "5%", cellsalign: "center" },
        { text: "Ancho", datafield: "U_ancho", width: "5%", cellsalign: "center" },
        { text: "Alto", datafield: "U_alto", width: "5%", cellsalign: "center" },
        { text: "Largo", datafield: "U_largo", width: "5%", cellsalign: "center" },
        { text: "KN/KG", datafield: "U_KNKG", width: "5%", cellsalign: "center" },
        { text: "F1", datafield: "U_N1", width: "5%", cellsalign: "center" },
        { text: "F2", datafield: "U_N2", width: "5%", cellsalign: "center" },
        { text: "TipoForm", datafield: "U_tipoFormula", width: "5%", cellsalign: "center" },
        { text: "A. Bruta (cm2)", datafield: "U_ABruta", width: "10%", cellsalign: "center" },
        { text: "Area bruta (Kg/Cm2)", datafield: "U_SBruta1", width: "10%", cellsalign: "center" },
        { text: "Rs Produccion", datafield: "U_resisProd", width: "10%", cellsalign: "center" },
        { text: "% Resistencia", datafield: "U_R1", width: "10%", cellsalign: "center" },
        { text: "Area bruta (Kg/Cm2) Promedio", datafield: "U_SBrutaProm", width: "15%", cellsalign: "center" },
        { text: "%R Promedio", datafield: "U_RProm", width: "10%", cellsalign: "center" },
      ],
    };
    this.myGridModalArticulos = createRef();
  }

  componentDidMount() {
    this.cargarDatosIniciales();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isLoading && this.state.isLoading) {
      Swal.fire({
        title: "Cargando...",
        text: "Espere un momento",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => { Swal.showLoading(); },
      });
    }
    if (prevState.isLoading && !this.state.isLoading) {
      Swal.close();
    }
  }

  getVisibleRowCount = () => this.state.esPrueba ? FILAS_PRUEBA : FILAS_NORMAL;
  getRowsToSave = () => this.state.data.slice(0, this.getVisibleRowCount());
  norm = (x) => (x == null ? "" : String(x).trim().toUpperCase());

  formatFechaOT = (fecha) => {
    if (!fecha) return "";
    const texto = String(fecha).trim();
    const matchPeriodoDiaMes = texto.match(/^(\d{4})\.(\d{1,2})(\d{2})$/);
    if (matchPeriodoDiaMes) {
      const [, periodo, dia, mes] = matchPeriodoDiaMes;
      return `${periodo}.${dia.padStart(2, "0")}${mes.padStart(2, "0")}`;
    }
    const matchYMD = texto.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (matchYMD) {
      const [, yyyy, mm, dd] = matchYMD;
      return `${yyyy}.${dd}${mm}`;
    }
    const matchDMY = texto.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
    if (matchDMY) {
      const [, dd, mm, yyyy] = matchDMY;
      return `${yyyy}.${dd.padStart(2, "0")}${mm.padStart(2, "0")}`;
    }
    const d = new Date(texto);
    if (isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}.${dd}${mm}`;
  };

  getPrefijoPlantaOT = (planta) => {
    const p = this.norm(planta);
    if (!p) return "";
    const matchCKC = p.match(/^CKC\s+(K\d+)$/i);
    if (matchCKC) return matchCKC[1].toUpperCase();
    const matchPV = p.match(/^PV([A-Z]\d*)$/i);
    if (matchPV) return matchPV[1].toUpperCase();
    const partes = p.split(/\s+/);
    return partes[partes.length - 1] || "";
  };

  getInicialOperador = (operador) => {
    const op = this.norm(operador);
    return op ? op.charAt(0) : "";
  };

  generarOT = (row) => {
    const planta = this.getPrefijoPlantaOT(row.Planta);
    const fecha = this.formatFechaOT(row.Fecha);
    const inicial = this.getInicialOperador(row.Operador);
    const resisProd = row.ResisProd ? `(${String(row.ResisProd).trim()})` : "";
    const boleta = row.Boleta ? String(row.Boleta).trim() : "";
    if (!planta || !fecha || !inicial || !resisProd || !boleta) return "";
    return `${planta}${fecha}${inicial}${resisProd}${boleta}`;
  };

  mapBackendRow = (row) => ({
    FechaEnsayo: this.formatYMD(row.U_fechaEnsayo),
    FechaRecepcion: this.formatYMD(row.U_fechaRecepcion),
    Fecha: this.formatYMD(row.U_fechaProduccion),
    EdadDias: row.U_diasEdad ?? "",
    Boleta: row.U_boleta ?? "",
    Planta: row.U_planta ?? "",
    Molde: this.norm(row.U_molde),
    Operador: this.norm(row.U_operador),
    UM: row.U_um ?? "",
    Producto: row.U_producto ?? "",
    Produccion: row.U_produccion ?? "",
    OT: row.U_ot ?? "",
    GrosorPared: row.U_grosorPared ?? "",
    PesoLb: row.U_peso ?? "",
    KN: row.U_kn ?? "",
    Ancho: row.U_ancho ?? "",
    Alto: row.U_alto ?? "",
    Largo: row.U_largo ?? "",
    U_KNKG: row.U_KNKG ?? "",
    U_N1: row.U_N1 ?? "",
    U_N2: row.U_N2 ?? "",
    U_TipoFormula: row.U_tipoFormula ?? "",
    ABruta: row.U_ABruta ?? "",
    SBruta1: row.U_SBruta1 ?? "",
    ResisProd: row.U_resisProd != null && row.U_resisProd !== ""
      ? String(Math.round(parseFloat(row.U_resisProd))) : "",
    R1: row.U_R1 ?? "",
    SBrutaProm: row.U_SBrutaProm ?? "",
    RProm: row.U_RProm ?? "",
    SBruta2: "",
    SNeta2: "",
    R2: "",
  });

  formatYMD = (val) => {
    if (!val) return "";
    try {
      const texto = String(val).trim();
      const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) return `${match[1]}-${match[2]}-${match[3]}`;
      const d = new Date(val);
      if (Number.isNaN(d.getTime())) return "";
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    } catch { return ""; }
  };

  recalcularPromedios = (newData) => {
    for (let i = 0; i < newData.length; i += 3) {
      const grupo = newData.slice(i, i + 3);
      const sBrutaVals = grupo.map((r) => parseFloat(r.SBruta1)).filter((v) => !isNaN(v));
      const rVals = grupo.map((r) => parseFloat(r.R1)).filter((v) => !isNaN(v));
      let sBrutaProm = "";
      let rProm = "";
      if (sBrutaVals.length) sBrutaProm = (sBrutaVals.reduce((a, b) => a + b, 0) / sBrutaVals.length).toFixed(2);
      if (rVals.length) rProm = Math.round(rVals.reduce((a, b) => a + b, 0) / rVals.length).toString();
      for (let j = 0; j < 3; j++) {
        if (newData[i + j]) {
          newData[i + j].SBrutaProm = sBrutaProm;
          newData[i + j].RProm = rProm;
        }
      }
    }
  };

  recalcularFormulaFila = (fila) => {
    const truncarDecimales = (num, decimales) => {
      const factor = Math.pow(10, decimales);
      return Math.trunc(num * factor) / factor;
    };
    const ancho = parseFloat(fila.Ancho);
    const largo = parseFloat(fila.Largo);
    const alto = parseFloat(fila.Alto);
    const tipoFormula = parseInt(fila.U_TipoFormula);
    const knkg = parseFloat(fila.U_KNKG);
    const n1 = parseFloat(fila.U_N1);
    const n2 = parseFloat(fila.U_N2);
    const kn = parseFloat(fila.KN);
    const resisProd = parseFloat(fila.ResisProd);

    if (!isNaN(ancho) && !isNaN(alto)) {
      if (tipoFormula === 1 || tipoFormula === 2) {
        fila.ABruta = truncarDecimales(2 * ancho * alto * alto, 2).toString();
      } else if (!isNaN(largo)) {
        fila.ABruta = truncarDecimales(ancho * largo, 2).toString();
      } else { fila.ABruta = ""; }
    } else { fila.ABruta = ""; }

    const aBrutaVal = parseFloat(fila.ABruta);
    if (!isNaN(aBrutaVal) && aBrutaVal !== 0 && !isNaN(knkg)) {
      if (tipoFormula === 1 || tipoFormula === 2) {
        if (!isNaN(n1) && !isNaN(n2) && !isNaN(kn)) {
          fila.SBruta1 = truncarDecimales((knkg * n1 * n2 * kn) / aBrutaVal, 2).toString();
        } else { fila.SBruta1 = ""; }
      } else if (!isNaN(kn)) {
        fila.SBruta1 = truncarDecimales((knkg * kn) / aBrutaVal, 2).toString();
      } else { fila.SBruta1 = ""; }
    } else { fila.SBruta1 = ""; }

    const sBrutaVal = parseFloat(fila.SBruta1);
    if (!isNaN(sBrutaVal) && !isNaN(resisProd) && resisProd !== 0) {
      fila.R1 = Math.trunc((sBrutaVal / resisProd) * 100).toString();
    } else { fila.R1 = ""; }
    return fila;
  };

  openModal = (rowIndex) => {
    this.setState({ selectedRowIndex: rowIndex, isModalOpen: true, isLoading: true });
    const token = localStorage.getItem("token");
    const token_Data = token ? JSON.parse(token) : null;
    if (!token_Data) { alert("No tienes token o acceso válido"); this.setState({ isLoading: false }); return; }
    const { usuarioSAP: username, contraseñaSAP: password } = token_Data[0];
    fetch(`${dominio}/get_ListaCodigosCalcResis`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    })
      .then(async (res) => {
        const dataCodigos = await res.json();
        if (_.isEmpty(dataCodigos)) { alert("No hay datos"); this.setState({ isLoading: false }); return; }
        const source_Array = dataCodigos.map(
          ({ ItemCode, ItemName, Planta, U_KNKG, U_N1, U_N2, U_TipoFormula }) => [
            ItemCode, ItemName, Planta, U_KNKG, U_N1, U_N2, U_TipoFormula,
          ]
        );
        const temp_source_grid = {
          localdata: source_Array,
          datafields: [
            { name: "ItemCode", type: "string", map: "0" },
            { name: "ItemName", type: "string", map: "1" },
            { name: "Planta", type: "string", map: "2" },
            { name: "U_KNKG", type: "number", map: "3" },
            { name: "U_N1", type: "number", map: "4" },
            { name: "U_N2", type: "number", map: "5" },
            { name: "U_TipoFormula", type: "number", map: "6" },
          ],
          datatype: "array",
        };
        this.setState({ sourceGridCodigos: new window.jqx.dataAdapter(temp_source_grid), isLoading: false });
      })
      .catch((err) => { console.error(err); alert("Error en el servidor"); this.setState({ isLoading: false }); });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, selectedRowIndex: null, sourceGridCodigos: null });
  };

  handleSelectCodigo = (row) => {
    const { selectedRowIndex, data } = this.state;
    if (selectedRowIndex !== null) {
      const newData = [...data];
      newData[selectedRowIndex] = {
        ...newData[selectedRowIndex],
        Planta: row.Planta,
        Producto: row.ItemName,
        U_KNKG: row.U_KNKG,
        U_N1: row.U_N1,
        U_N2: row.U_N2,
        U_TipoFormula: row.U_TipoFormula,
      };

      newData[selectedRowIndex].OT =
        this.generarOT(newData[selectedRowIndex]) || newData[selectedRowIndex].OT;

      if (selectedRowIndex === 0) {
        for (let i = 1; i < TOTAL_FILAS && i < newData.length; i++) {
          newData[i] = {
            ...newData[i],
            Planta: row.Planta,
            Producto: row.ItemName,
            U_KNKG: row.U_KNKG,
            U_N1: row.U_N1,
            U_N2: row.U_N2,
            U_TipoFormula: row.U_TipoFormula,
          };
          newData[i].OT = this.generarOT(newData[i]) || newData[i].OT;
        }
      }

      this.recalcularPromedios(newData);
      this.setState({ data: newData }, this.closeModal);
    }
  };

  handleInputChange = (index, field, value) => {
    if (field === "Molde" || field === "Operador") value = this.norm(value);
    if (typeof value === "object" && value !== null && value.value !== undefined) value = value.value;

    if (field === "ResisProd" && value !== "") {
      const entero = Math.round(parseFloat(value));
      if (!isNaN(entero)) value = String(entero);
    }

    const newData = [...this.state.data];
    const otAnterior = newData[index].OT;
    newData[index] = { ...newData[index], [field]: value };

    if (field === "Molde") {
      const moldeSeleccionado = this.state.moldesOptions.find(
        (m) => this.norm(m.value) === this.norm(value)
      );
      if (moldeSeleccionado) newData[index].UM = moldeSeleccionado.UM;
    }

    if (field === "EdadDias") {
      const edad = parseInt(value);
      const fechaProduccion = new Date(newData[index].Fecha);
      if (!isNaN(edad) && fechaProduccion instanceof Date && !isNaN(fechaProduccion.getTime())) {
        const nuevaFecha = new Date(fechaProduccion);
        nuevaFecha.setDate(nuevaFecha.getDate() + edad);
        newData[index].FechaEnsayo = nuevaFecha.toISOString().split("T")[0];
      }
      if (index % 3 === 0) {
        for (let j = 1; j <= 2; j++) {
          if (newData[index + j]) {
            newData[index + j].EdadDias = value;
            const fp = new Date(newData[index + j].Fecha);
            if (!isNaN(edad) && !isNaN(fp.getTime())) {
              const nf = new Date(fp);
              nf.setDate(nf.getDate() + edad);
              newData[index + j].FechaEnsayo = nf.toISOString().split("T")[0];
            }
          }
        }
      }
    }

    const camposParaPropagar = [
      "FechaRecepcion", "Fecha", "Boleta", "Molde", "Operador", "UM",
      "Produccion", "GrosorPared", "Ancho", "Alto", "Largo",
      "U_KNKG", "U_N1", "U_N2", "U_TipoFormula", "ResisProd",
    ];

    if (index === 0 && camposParaPropagar.includes(field)) {
      const valorPropagado = field === "Molde" || field === "Operador" ? this.norm(value) : value;
      for (let i = 1; i < TOTAL_FILAS && i < newData.length; i++) {
        newData[i] = { ...newData[i], [field]: valorPropagado };
        if (field === "Molde") {
          const moldeSeleccionado = this.state.moldesOptions.find(
            (m) => this.norm(m.value) === this.norm(valorPropagado)
          );
          if (moldeSeleccionado) newData[i].UM = moldeSeleccionado.UM;
        }
      }
    }

    const camposFormula = ["Ancho", "Largo", "Alto", "U_TipoFormula", "U_KNKG", "U_N1", "U_N2", "KN", "ResisProd"];
    if (camposFormula.includes(field)) {
      newData[index] = this.recalcularFormulaFila(newData[index]);
      if (index === 0) {
        for (let i = 1; i < TOTAL_FILAS && i < newData.length; i++) {
          newData[i] = this.recalcularFormulaFila(newData[i]);
        }
      }
    }

    if (field !== "OT") {
      const otGenerada = this.generarOT(newData[index]);
      newData[index].OT = otGenerada || otAnterior || newData[index].OT;
    }

    if (index === 0 && field !== "OT") {
      for (let i = 1; i < TOTAL_FILAS && i < newData.length; i++) {
        const otGenerada = this.generarOT(newData[i]);
        newData[i].OT = otGenerada || newData[i].OT;
      }
    }

    this.recalcularPromedios(newData);
    this.setState({ data: newData });
  };

  handleEnviarDatos = async () => {
    const confirmacion = await Swal.fire({
      title: "¿Está seguro?", text: "Se enviarán los datos al servidor",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Sí, enviar", cancelButtonText: "Cancelar",
    });
    if (!confirmacion.isConfirmed) return;
    this.setState({ isLoading: true });

    try {
      let username = ""; let password = "";
      const token = localStorage.getItem("token");
      const token_Data = token ? JSON.parse(token) : null;
      if (Array.isArray(token_Data) && token_Data.length > 0) {
        const { usuarioSAP, contraseñaSAP } = token_Data[0];
        username = usuarioSAP; password = contraseñaSAP;
      } else { this.props.history.push("/login"); return; }

      const isEmpty = (v) => v === null || v === undefined || (typeof v === "string" && v.trim() === "");
      const filasAGuardar = this.getRowsToSave();

      if (!Array.isArray(filasAGuardar) || filasAGuardar.length === 0) {
        Swal.fire({ icon: "warning", title: "Sin datos", text: "No hay datos para enviar." }); return;
      }

      const requiredFields = [{ label: "OT", get: (r) => r.OT ?? r.U_ot }];
      const errores = []; const datosFiltrados = [];

      filasAGuardar.forEach((row, idx) => {
        if (!row || Object.values(row).every(isEmpty)) return;
        const faltantes = requiredFields.filter((f) => isEmpty(f.get(row))).map((f) => f.label);
        if (faltantes.length) {
          errores.push(`Fila ${idx + 1}: ${faltantes.join(", ")} vací${faltantes.length > 1 ? "os" : "o"}.`);
        } else { datosFiltrados.push(row); }
      });

      if (errores.length) {
        await Swal.fire({
          icon: "error", title: "Campos vacíos o nulos",
          html: `<div style="text-align:left">${errores.map((e) => `• ${e}`).join("<br/>")}</div>`,
        }); return;
      }
      if (datosFiltrados.length === 0) {
        await Swal.fire({ icon: "warning", title: "Sin datos válidos", text: "No hay registros válidos para enviar." }); return;
      }

      const response = await fetch(`${dominio}/nuevoCalculoR`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, datos: datosFiltrados }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || `Error del servidor: ${response.status}`);
      if (!result.success) throw new Error(result.error || "Error desconocido en el servidor");

      Swal.fire({ icon: "success", title: "¡Enviado!", text: "Los datos fueron enviados correctamente", timer: 2000, showConfirmButton: false })
        .then(() => { window.location.reload(); });
    } catch (error) {
      console.error("Error al enviar:", error);
      Swal.fire({ icon: "error", title: "Error", text: error.message || "No se pudieron enviar los datos." });
    } finally { this.setState({ isLoading: false }); }
  };

  handleEditarRegistro = async () => {
    const confirmacion = await Swal.fire({
      title: "¿Está seguro?", text: "Se actualizarán los datos en el servidor",
      icon: "warning", showCancelButton: true,
      confirmButtonText: "Sí, actualizar", cancelButtonText: "Cancelar",
    });
    if (!confirmacion.isConfirmed) return;
    this.setState({ isLoading: true });

    let exitoso = false;
    let errorGuardado = null;
    const otOriginal = this.state.otOriginal;

    try {
      const token = localStorage.getItem("token");
      const token_Data = token ? JSON.parse(token) : null;
      if (!Array.isArray(token_Data) || token_Data.length === 0) { this.props.history.push("/login"); return; }
      const { usuarioSAP: username, contraseñaSAP: password } = token_Data[0];
      const filasAGuardar = this.getRowsToSave();

      if (!Array.isArray(filasAGuardar) || filasAGuardar.length === 0) {
        await Swal.fire({ icon: "warning", title: "Sin datos", text: "No hay datos para actualizar." }); return;
      }

      const response = await fetch(`${dominio}/registrarCalculoR`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            username,
            password,
            datos: filasAGuardar,
            otOriginal: otOriginal,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || `Error del servidor: ${response.status}`);
      if (!result.success) throw new Error(result.error || "Error desconocido en el servidor");

      exitoso = true;
    } catch (error) {
      console.error("Error al actualizar:", error);
      errorGuardado = error.message || "No se pudieron actualizar los datos.";
    } finally {
      this.setState({ isLoading: false }, async () => {
        if (exitoso) {
          const nuevaOT = (this.getRowsToSave().find(r => r.OT) || {}).OT || "";
          const otCambio = nuevaOT && nuevaOT !== otOriginal;

          if (otCambio) {
            const respEliminar = await Swal.fire({
              icon: "question",
              title: "OT nueva generada",
              text: `Se generará una OT nueva. ¿Desea eliminar la OT anterior (${otOriginal})?`,
              showCancelButton: true,
              confirmButtonText: "Sí, eliminar",
              cancelButtonText: "Guardar ambos registros",
              confirmButtonColor: "#d33",
            });
            if (respEliminar.isConfirmed) {
              try {
                const token = localStorage.getItem("token");
                const token_Data = token ? JSON.parse(token) : null;
                const { usuarioSAP: username, contraseñaSAP: password } = token_Data[0];
                await fetch(`${dominio}/eliminarCalculoR`, {
                  method: "POST", headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ username, password, ot: otOriginal }),
                });
              } catch (e) {
                console.error("Error al eliminar OT anterior:", e);
              }
            }
          } else {
            await Swal.fire({ icon: "success", title: "¡Actualizado!", text: "Los datos fueron actualizados correctamente", timer: 2000, showConfirmButton: false });
          }
          window.location.reload();
        } else if (errorGuardado) {
          await Swal.fire({ icon: "error", title: "Error al actualizar", text: errorGuardado });
        }
      });
    }
  };

  handleEliminarOT = async () => {
    const ot = (this.state.otEliminar || "").toString().trim();
    if (!ot) { await Swal.fire({ icon: "warning", title: "OT requerida", text: "Ingrese la OT a eliminar." }); return; }
    const confirmacion = await Swal.fire({
      title: "¿Eliminar OT?", text: `Se eliminarán los registros asociados a la OT ${ot}.`,
      icon: "warning", showCancelButton: true, confirmButtonText: "Sí, eliminar", cancelButtonText: "Cancelar",
    });
    if (!confirmacion.isConfirmed) return;
    this.setState({ isLoading: true });

    try {
      const token = localStorage.getItem("token");
      const token_Data = token ? JSON.parse(token) : null;
      if (!token_Data) { await Swal.fire({ icon: "error", title: "Sesión", text: "No hay token o acceso válido." }); return; }
      const { usuarioSAP: username, contraseñaSAP: password } = token_Data[0];
      const resp = await fetch(`${dominio}/eliminarCalculoR`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, ot }),
      });
      const result = await resp.json();
      if (!resp.ok) throw new Error(result.error || `Error del servidor: ${resp.status}`);
      if (!result.success) throw new Error(result.error || "No se pudo eliminar la OT.");

      await Swal.fire({ icon: "success", title: "OT eliminada", text: `La OT ${ot} se eliminó correctamente.`, timer: 2000, showConfirmButton: false });
      window.location.reload();
      this.setState({ otEliminar: "", otBusqueda: "", mostrarCrear: true, mostrarEditar: false, esPrueba: false, data: Array.from({ length: TOTAL_FILAS }, crearFilaVacia) });
    } catch (e) {
      console.error(e);
      await Swal.fire({ icon: "error", title: "Error al eliminar", text: e.message || "No fue posible eliminar la OT." });
    } finally { this.setState({ isLoading: false }); }
  };

  dataCalculosRegistrados = () => {
    const { filtroFechaDesde, filtroFechaHasta, filtroPlanta, filtroProducto } = this.state;
    if (!filtroFechaDesde || !filtroFechaHasta) {
      Swal.fire({ icon: "warning", title: "Filtros requeridos", text: "Ingrese el rango de fechas para buscar registros." });
      return;
    }
    this.setState({ source_grid: null, isLoading: true });
    let username = ""; let password = "";
    const token = localStorage.getItem("token");
    const token_Data = token ? JSON.parse(token) : null;
    if (token_Data !== null) { token_Data.forEach((element) => { username = element.usuarioSAP; password = element.contraseñaSAP; }); }
    if (token_Data === null) { this.props.history.push(""); this.setState({ isLoading: false }); return; }

    fetch(`${dominio}/get_AllCalcResis`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password, fechaDesde: filtroFechaDesde, fechaHasta: filtroFechaHasta, planta: filtroPlanta, producto: filtroProducto }),
    })
      .then(async (res) => {
        const dataBoleta = await res.json();
        if (Object.entries(dataBoleta).length === 0) {
          this.setState({ isLoading: false, message: "No data", source_grid: "", otCount: 0 });
          Swal.fire({
            icon: "info",
            title: "Sin resultados",
            text: "No se encontraron registros con los filtros seleccionados.",
            confirmButtonText: "OK",
          });
          return;
        }
        const otUnicas = new Set(dataBoleta.map((e) => e.U_ot));
        const source_Array = [];
        dataBoleta.forEach((element) => {
          source_Array.push([
            element.U_fechaEnsayo, element.U_fechaRecepcion, element.U_fechaProduccion,
            element.U_diasEdad, element.U_boleta, element.U_planta, element.U_molde,
            element.U_operador, element.U_um, element.U_producto, element.U_produccion,
            element.U_ot, element.U_grosorPared, element.U_peso, element.U_kn,
            element.U_ancho, element.U_alto, element.U_largo, element.U_KNKG,
            element.U_N1, element.U_N2, element.U_tipoFormula, element.U_ABruta,
            element.U_SBruta1, element.U_resisProd, element.U_R1,
            element.U_SBrutaProm, element.U_RProm,
          ]);
        });
        const temp_source_grid = {
          localdata: source_Array,
          datafields: [
            { name: "U_fechaEnsayo", type: "string", map: "0" }, { name: "U_fechaRecepcion", type: "string", map: "1" },
            { name: "U_fechaProduccion", type: "string", map: "2" }, { name: "U_diasEdad", type: "number", map: "3" },
            { name: "U_boleta", type: "number", map: "4" }, { name: "U_planta", type: "string", map: "5" },
            { name: "U_molde", type: "string", map: "6" }, { name: "U_operador", type: "string", map: "7" },
            { name: "U_um", type: "number", map: "8" }, { name: "U_producto", type: "string", map: "9" },
            { name: "U_produccion", type: "number", map: "10" }, { name: "U_ot", type: "string", map: "11" },
            { name: "U_grosorPared", type: "number", map: "12" }, { name: "U_peso", type: "number", map: "13" },
            { name: "U_kn", type: "number", map: "14" }, { name: "U_ancho", type: "number", map: "15" },
            { name: "U_alto", type: "number", map: "16" }, { name: "U_largo", type: "number", map: "17" },
            { name: "U_KNKG", type: "number", map: "18" }, { name: "U_N1", type: "number", map: "19" },
            { name: "U_N2", type: "number", map: "20" }, { name: "U_tipoFormula", type: "number", map: "21" },
            { name: "U_ABruta", type: "number", map: "22" }, { name: "U_SBruta1", type: "number", map: "23" },
            { name: "U_resisProd", type: "number", map: "24" }, { name: "U_R1", type: "number", map: "25" },
            { name: "U_SBrutaProm", type: "number", map: "26" }, { name: "U_RProm", type: "number", map: "27" },
          ],
          datatype: "array",
        };
        this.setState({ source_grid: new jqx.dataAdapter(temp_source_grid), isLoading: false, message: "", otCount: otUnicas.size });
      })
      .catch((error) => { console.log(error); this.setState({ message: "error in server", isLoading: false }); });
  };

  cargarDatosIniciales = () => {
    const token = localStorage.getItem("token");
    const token_Data = token ? JSON.parse(token) : null;
    if (!token_Data) { alert("No tienes token o acceso válido"); return; }
    const { usuarioSAP: username, contraseñaSAP: password } = token_Data[0];
    fetch(`${dominio}/get_InitDataCalcResis`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ username, password }) })
      .then(async (res) => {
        const data = await res.json();
        this.setState({
          moldesOptions: (data.moldes || []).map((m) => ({ value: this.norm(m.Molde), label: this.norm(m.Molde), UM: m.UM })),
          operadoresOptions: (data.operadores || []).map((o) => ({ value: this.norm(o.Operador), label: this.norm(o.Operador) })),
          plantasOptions: (data.plantas || []).map((p) => p.Planta),
          productosOptions: (data.productos || []).map((p) => p.Producto),
        });
      })
      .catch((error) => { console.error("Error al cargar datos iniciales:", error); });
  };

  handleBuscarOT = async () => {
    const hayResultados = await this.buscarPorOT();
    this.setState({ mostrarCrear: !hayResultados, mostrarEditar: !!hayResultados });
  };

  buscarPorOT = async () => {
    const ot = (this.state.otBusqueda || "").toString().trim();
    if (!ot) { Swal.fire({ icon: "warning", title: "OT requerida", text: "Ingrese una OT para buscar." }); return false; }
    this.setState({ isLoading: true });
    try {
      const token = localStorage.getItem("token");
      const token_Data = token ? JSON.parse(token) : null;
      if (!token_Data) { Swal.fire({ icon: "error", title: "Sesión", text: "No hay token o acceso válido." }); return false; }
      const { usuarioSAP: username, contraseñaSAP: password } = token_Data[0];
      const resp = await fetch(`${dominio}/get_OtCalcResis`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, ot }),
      });
      if (!resp.ok) { const msg = await resp.text(); throw new Error(msg || `Error HTTP ${resp.status}`); }
      const rows = await resp.json();
      if (!Array.isArray(rows) || rows.length === 0) {
        Swal.fire({ icon: "info", title: "Sin resultados", text: `No se encontraron datos para la OT ${ot}.` }); return false;
      }

      const mapped = rows.slice(0, TOTAL_FILAS).map(this.mapBackendRow);
      while (mapped.length < TOTAL_FILAS) {
        const fila = crearFilaVacia();
        fila.OT = ot;
        mapped.push(fila);
      }

      const esPrueba = rows.length > FILAS_NORMAL;

      this.recalcularPromedios(mapped);
      //this.setState({ data: mapped, esPrueba });
      this.setState({ data: mapped, esPrueba, otOriginal: ot });
      Swal.fire({ icon: "success", title: "Datos cargados", text: `Se cargaron ${Math.min(rows.length, TOTAL_FILAS)} fila(s) para la OT ${ot}.`, timer: 1800, showConfirmButton: false });
      return true;
    } catch (e) {
      console.error(e);
      Swal.fire({ icon: "error", title: "Error al consultar", text: e.message || "No fue posible obtener los datos." });
      return false;
    } finally { this.setState({ isLoading: false }); }
  };

  render() {
    const { data, isModalOpen, sourceGridCodigos, esPrueba } = this.state;
    const filasVisibles = data.slice(0, this.getVisibleRowCount());

    const columnsModal = [
      { text: "ItemCode", datafield: "ItemCode", width: "15%" },
      { text: "ItemName", datafield: "ItemName", width: "40%" },
      { text: "Planta", datafield: "Planta", width: "10%" },
      { text: "KNKG", datafield: "U_KNKG", width: "7%" },
      { text: "N1", datafield: "U_N1", width: "5%" },
      { text: "N2", datafield: "U_N2", width: "5%" },
      { text: "TipoFor", datafield: "U_TipoFormula", width: "7%" },
      {
        text: " ", datafield: "Seleccionar", columntype: "button", cellsrenderer: () => "+",
        buttonclick: (row) => { const rowData = this.myGridModalArticulos.current.getrowdata(row); this.handleSelectCodigo(rowData); },
        width: "10%",
      },
    ];

    return (
      <div className="content text-center">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="CALCULO DE RESISTENCIAS"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <>
                    <p style={{ fontWeight: "bold", color: "red", fontSize: "12px" }}>Buscar registro por OT</p>

                    <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12 }}>
                      <input
                        type="text" placeholder="Ingrese OT..." style={{ maxWidth: 220 }}
                        value={this.state.otBusqueda}
                        onChange={(e) => {
                          const v = e.target.value;
                          this.setState({ otBusqueda: v, ...(v.trim() === "" ? { mostrarCrear: true, mostrarEditar: false } : {}) });
                        }}
                        onKeyDown={(e) => { if (e.key === "Enter") this.handleBuscarOT(); }}
                      />
                      <button className="btn btn-secondary" onClick={this.handleBuscarOT}>Buscar OT</button>
                    </div>

                    <div className="d-flex align-items-center justify-content-center" style={{ gap: 8, marginBottom: 12 }}>
                      <input id="chkPrueba" type="checkbox" checked={esPrueba}
                        onChange={(e) => this.setState({ esPrueba: e.target.checked })} />
                      <label htmlFor="chkPrueba" style={{ margin: 0, fontWeight: "bold" }}>Prueba</label>
                    </div>

                    <br />

                    {this.state.mostrarEditar && (
                      <div style={{ backgroundColor: "#fff3cd", border: "1px solid #ffc107", borderRadius: "4px", padding: "8px 14px", marginBottom: "10px", fontWeight: "bold", color: "#856404", fontSize: "13px" }}>
                        Editando registro — OT: {this.state.otOriginal}
                      </div>
                    )}

                    <div style={styles.tableContainer}>
                      <table style={styles.table}>
                        <thead>
                          <tr>
                            <th style={styles.th}>F. Ensayo</th>
                            <th style={styles.th}>F. Recepción</th>
                            <th style={styles.th}>Fecha Produccion</th>
                            <th style={styles.th}>Edad (Días)</th>
                            <th style={styles.th}>Boleta</th>
                            <th style={styles.th}>Planta</th>
                            <th style={styles.th}>Molde</th>
                            <th style={styles.th}>Operador</th>
                            <th style={styles.th}>U/M</th>
                            <th style={styles.th}>Producto</th>
                            <th style={styles.th}>Seleccionar Producto</th>
                            <th style={styles.th}>Producción</th>
                            <th style={styles.th}>OT</th>
                            <th style={styles.th}>Grosor Pared</th>
                            <th style={styles.th}>Peso (Lb)</th>
                            <th style={styles.th}>KN</th>
                            <th style={styles.th}>Ancho</th>
                            <th style={styles.th}>Alto</th>
                            <th style={styles.th}>Largo</th>
                            <th style={styles.th}>U_KNKG</th>
                            <th style={styles.th}>U_N1</th>
                            <th style={styles.th}>U_N2</th>
                            <th style={styles.th}>U_TipoFormula</th>
                            <th style={styles.th}>A. Bruta (cm2)</th>
                            <th style={styles.th}>Area bruta (Kg/Cm2)</th>
                            <th style={styles.th}>Rs Produccion</th>
                            <th style={styles.th}>% Resistencia</th>
                            <th style={styles.th}>Area bruta (Kg/Cm2) Promedio</th>
                            <th style={styles.th}>%R Promedio</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filasVisibles.map((row, i) => {
                            const isFirst = i === 0;
                            const isLast = i === filasVisibles.length - 1;
                            const isSeparator = (i + 1) % 3 === 0 && i !== filasVisibles.length - 1;
                            let rowStyle = { ...styles.rowSideBorders };
                            if (isFirst) rowStyle = { ...rowStyle, ...styles.rowTopBorder };
                            if (isSeparator) rowStyle = { ...rowStyle, ...styles.rowSeparator };
                            if (isLast) rowStyle = { ...rowStyle, ...styles.rowBottomBorder };

                            const moldeOpt =
                              this.state.moldesOptions.find((opt) => this.norm(opt.value) === this.norm(row.Molde)) ||
                              (row.Molde ? { value: this.norm(row.Molde), label: this.norm(row.Molde) } : null);

                            const operadorOpt =
                              this.state.operadoresOptions.find((opt) => this.norm(opt.value) === this.norm(row.Operador)) ||
                              (row.Operador ? { value: this.norm(row.Operador), label: this.norm(row.Operador) } : null);

                            return (
                              <tr key={i} style={rowStyle}>
                                <td style={styles.tdMediano}>
                                  {row.FechaEnsayo ? row.FechaEnsayo.toString().substring(0, 10) : ""}
                                </td>
                                <td style={styles.td}>
                                  <input style={styles.input} type="date" value={row.FechaRecepcion || ""}
                                    onChange={(e) => this.handleInputChange(i, "FechaRecepcion", e.target.value)} />
                                </td>
                                <td style={styles.td}>
                                  <input style={styles.input} type="date" value={row.Fecha || ""}
                                    onChange={(e) => this.handleInputChange(i, "Fecha", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="number" value={row.EdadDias}
                                    onChange={(e) => this.handleInputChange(i, "EdadDias", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.Boleta}
                                    onChange={(e) => this.handleInputChange(i, "Boleta", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>{row.Planta}</td>
                                <td style={styles.tdMedianoCombo}>
                                  <CreatableSelect
                                    options={this.state.moldesOptions} value={moldeOpt}
                                    onChange={(opt) => this.handleInputChange(i, "Molde", opt ? opt.value : "")}
                                    onCreateOption={(inputValue) => {
                                      const value = this.norm(inputValue);
                                      const newOption = { value, label: value };
                                      this.setState((prev) => {
                                        const exists = (prev.moldesOptions || []).some((o) => this.norm(o.value) === value);
                                        return { moldesOptions: exists ? prev.moldesOptions : [...(prev.moldesOptions || []), newOption] };
                                      });
                                      this.handleInputChange(i, "Molde", value);
                                    }}
                                    formatCreateLabel={(inputValue) => `Agregar "${this.norm(inputValue)}"`}
                                    onInputChange={(val, meta) => meta.action === "input-change" ? this.norm(val) : val}
                                    styles={{
                                      control: (base) => ({ ...base, minHeight: 28, height: 28, fontSize: 11, paddingTop: 0, paddingBottom: 0 }),
                                      indicatorsContainer: (base) => ({ ...base, height: 28 }),
                                      valueContainer: (base) => ({ ...base, paddingTop: 0, paddingBottom: 0, height: 28 }),
                                      input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                      dropdownIndicator: (base) => ({ ...base, padding: 2 }),
                                      clearIndicator: (base) => ({ ...base, padding: 2 }),
                                      menu: (base) => ({ ...base, fontSize: 12 }),
                                    }}
                                    placeholder="Seleccione o escriba..." isClearable
                                  />
                                </td>
                                <td style={styles.tdMedianoComboOP}>
                                  <CreatableSelect
                                    options={this.state.operadoresOptions} value={operadorOpt}
                                    onChange={(opt) => this.handleInputChange(i, "Operador", opt ? opt.value : "")}
                                    onCreateOption={(inputValue) => {
                                      const value = this.norm(inputValue);
                                      const newOption = { value, label: value };
                                      this.setState((prev) => {
                                        const exists = (prev.operadoresOptions || []).some((o) => this.norm(o.value) === value);
                                        return { operadoresOptions: exists ? prev.operadoresOptions : [...(prev.operadoresOptions || []), newOption] };
                                      });
                                      this.handleInputChange(i, "Operador", value);
                                    }}
                                    formatCreateLabel={(inputValue) => `Agregar "${this.norm(inputValue)}"`}
                                    onInputChange={(val, meta) => meta.action === "input-change" ? this.norm(val) : val}
                                    styles={{
                                      control: (base) => ({ ...base, minHeight: 28, height: 28, fontSize: 11, paddingTop: 0, paddingBottom: 0 }),
                                      indicatorsContainer: (base) => ({ ...base, height: 28 }),
                                      valueContainer: (base) => ({ ...base, paddingTop: 0, paddingBottom: 0, height: 28 }),
                                      input: (base) => ({ ...base, margin: 0, padding: 0 }),
                                      dropdownIndicator: (base) => ({ ...base, padding: 2 }),
                                      clearIndicator: (base) => ({ ...base, padding: 2 }),
                                      menu: (base) => ({ ...base, fontSize: 12 }),
                                    }}
                                    placeholder="Seleccione o escriba..." isClearable
                                  />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.UM}
                                    onChange={(e) => this.handleInputChange(i, "UM", e.target.value)} />
                                </td>
                                <td style={styles.td}>{row.Producto}</td>
                                <td style={styles.tdMediano}>
                                  <button style={styles.button} onClick={() => this.openModal(i)}>+</button>
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.Produccion}
                                    onChange={(e) => this.handleInputChange(i, "Produccion", e.target.value)} />
                                </td>
                                <td style={styles.tdMedianoOT}>
                                  <input style={styles.input} type="text" value={row.OT}
                                    onChange={(e) => this.handleInputChange(i, "OT", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input
                                    style={{
                                      ...styles.input,
                                      border: row.GrosorPared === "" || isNaN(parseFloat(row.GrosorPared)) ? "" :
                                        `2px solid ${parseFloat(row.GrosorPared) >= 2.2 && parseFloat(row.GrosorPared) <= 2.8 ? "green" : "red"}`,
                                    }}
                                    type="text" value={row.GrosorPared}
                                    onChange={(e) => this.handleInputChange(i, "GrosorPared", e.target.value)}
                                  />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.PesoLb}
                                    onChange={(e) => this.handleInputChange(i, "PesoLb", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.KN}
                                    onChange={(e) => this.handleInputChange(i, "KN", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.Ancho}
                                    onChange={(e) => this.handleInputChange(i, "Ancho", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.Alto}
                                    onChange={(e) => this.handleInputChange(i, "Alto", e.target.value)} />
                                </td>
                                <td style={styles.tdMediano}>
                                  <input style={styles.input} type="text" value={row.Largo}
                                    onChange={(e) => this.handleInputChange(i, "Largo", e.target.value)} />
                                </td>
                                <td style={styles.td}>{row.U_KNKG}</td>
                                <td style={styles.td}>{row.U_N1}</td>
                                <td style={styles.td}>{row.U_N2}</td>
                                <td style={styles.td}>{row.U_TipoFormula}</td>
                                <td style={styles.tdMediano}>{row.ABruta}</td>
                                <td style={styles.td}>{row.SBruta1}</td>
                                <td style={styles.tdMediano}>
                                  <input
                                    style={styles.input}
                                    type="number"
                                    step="1"
                                    min="0"
                                    value={row.ResisProd}
                                    onChange={(e) => this.handleInputChange(i, "ResisProd", e.target.value)}
                                  />
                                </td>
                                <td style={styles.td}>{row.R1}</td>
                                {i % 3 === 0 ? (
                                  <>
                                    <td style={{ ...styles.td, ...styles.centeredCell }} rowSpan={3}>{filasVisibles[i].SBrutaProm}</td>
                                    <td style={{ ...styles.td, ...styles.centeredCell }} rowSpan={3}>{filasVisibles[i].RProm}</td>
                                  </>
                                ) : null}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <br />

                    {!this.state.mostrarEditar && (
                      <button className="btn btn-primary" onClick={this.handleEnviarDatos}>Crear Registro</button>
                    )}
                    {this.state.mostrarEditar && (
                      <button className="btn btn-warning" onClick={this.handleEditarRegistro}>Editar Registro</button>
                    )}

                    <br /><br />

                    {/* ── Filtros de registros ── */}
                    <div style={{ background: "#f5f5f5", borderRadius: "8px", marginBottom: "16px", padding: "10px 16px" }}>
                      {/* fila de labels */}
                      <div style={{ display: "grid", gridTemplateColumns: "140px 140px 160px 1fr auto", gap: "12px", marginBottom: "4px" }}>
                        {["Fecha Desde","Fecha Hasta","Planta","Producto",""].map((lbl, i) => (
                          <span key={i} style={{ fontSize: "10px", fontWeight: "700", textTransform: "uppercase", color: "#666", letterSpacing: "0.5px" }}>{lbl}</span>
                        ))}
                      </div>
                      {/* fila de inputs */}
                      <div style={{ display: "grid", gridTemplateColumns: "140px 140px 160px 1fr auto", gap: "12px", alignItems: "center" }}>
                        <input type="date" value={this.state.filtroFechaDesde}
                          onChange={(e) => this.setState({ filtroFechaDesde: e.target.value })}
                          style={{ height: "34px", padding: "4px 8px", fontSize: "13px", borderRadius: 4, border: "1px solid #ccc", width: "100%" }} />
                        <input type="date" value={this.state.filtroFechaHasta}
                          onChange={(e) => this.setState({ filtroFechaHasta: e.target.value })}
                          style={{ height: "34px", padding: "4px 8px", fontSize: "13px", borderRadius: 4, border: "1px solid #ccc", width: "100%" }} />
                        <Select
                          options={[{ value: "", label: "Todas" }, ...this.state.plantasOptions.map((p) => ({ value: p, label: p }))]}
                          value={this.state.filtroPlanta ? { value: this.state.filtroPlanta, label: this.state.filtroPlanta } : { value: "", label: "Todas" }}
                          onChange={(opt) => this.setState({ filtroPlanta: opt ? opt.value : "" })}
                          styles={{
                            control: (base) => ({ ...base, minHeight: 34, height: 34, fontSize: 13 }),
                            indicatorsContainer: (base) => ({ ...base, height: 34 }),
                            valueContainer: (base) => ({ ...base, height: 34, padding: "0 8px" }),
                            input: (base) => ({ ...base, margin: 0, padding: 0 }),
                            menu: (base) => ({ ...base, fontSize: 13, zIndex: 9999 }),
                          }}
                        />
                        <Select
                          options={[{ value: "", label: "Todos" }, ...this.state.productosOptions.map((p) => ({ value: p, label: p }))]}
                          value={this.state.filtroProducto ? { value: this.state.filtroProducto, label: this.state.filtroProducto } : { value: "", label: "Todos" }}
                          onChange={(opt) => this.setState({ filtroProducto: opt ? opt.value : "" })}
                          placeholder="Buscar producto..."
                          styles={{
                            control: (base) => ({ ...base, minHeight: 34, height: 34, fontSize: 13 }),
                            indicatorsContainer: (base) => ({ ...base, height: 34 }),
                            valueContainer: (base) => ({ ...base, height: 34, padding: "0 8px" }),
                            input: (base) => ({ ...base, margin: 0, padding: 0 }),
                            menu: (base) => ({ ...base, fontSize: 13, zIndex: 9999, minWidth: 480 }),
                            option: (base) => ({ ...base, whiteSpace: "nowrap", textAlign: "left" }),
                            singleValue: (base) => ({ ...base, textAlign: "left" }),
                          }}
                        />
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                          <button className="btn btn-info btn-sm" onClick={this.dataCalculosRegistrados}
                            style={{ height: "34px", fontSize: "13px", whiteSpace: "nowrap" }}>
                            Buscar Registros
                          </button>
                          {!_.isEmpty(this.state.source_grid) && (<>
                            <button className="btn btn-default btn-sm"
                              onClick={() => this.setState({ source_grid: "", filtroFechaDesde: "", filtroFechaHasta: "", filtroPlanta: "", filtroProducto: "", otCount: 0 })}
                              style={{ height: "34px", fontSize: "13px" }}>
                              Limpiar
                            </button>
                            <span style={{ fontSize: "13px", fontWeight: "bold", color: "#1a73e8", background: "#e8f0fe", borderRadius: "12px", padding: "4px 10px", whiteSpace: "nowrap" }}>
                              {this.state.otCount} OT{this.state.otCount !== 1 ? "s" : ""}
                            </span>
                          </>)}
                        </div>
                      </div>
                    </div>

                    {!_.isEmpty(this.state.source_grid) ? (
                      <div className="col-sm-12" style={{ marginBottom: 24 }}>
                        <JqxGrid
                          ref={myGrid} width={"100%"} columns={this.state.columns}
                          source={this.state.source_grid} theme={"material"} height={"600px"}
                          groupable={true} filterable={true} showfilterrow={true} altrows={true}
                          enabletooltips={true} columnsresize={true} showtoolbar={true} sortable={true}
                          showstatusbar={true} showaggregates={true} enablebrowserselection={true}
                          selectionmode={"multiplecellsadvanced"} clipboard={true}
                          groups={["U_ot", "U_boleta"]} groupsexpanded={[0, 1, 2]}
                        />
                      </div>
                    ) : ""}

                    {isModalOpen && (
                      <div style={styles.modalBackdrop} onClick={this.closeModal}>
                        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                          <div style={styles.modalHeader}>
                            <h5>Codigos</h5>
                            <button style={{ fontSize: "1.5rem", background: "none", border: "none" }} onClick={this.closeModal}>&times;</button>
                          </div>
                          <div style={styles.modalBody}>
                            {sourceGridCodigos && (
                              <JqxGrid
                                ref={this.myGridModalArticulos} theme={"material"} width={"100%"} height={"400"}
                                columns={columnsModal} source={sourceGridCodigos} filterable={true} editable={false}
                                showfilterrow={true} altrows={true} enabletooltips={true} columnsresize={true}
                                showtoolbar={true} sortable={true} showstatusbar={true} showaggregates={true}
                              />
                            )}
                          </div>
                          <div style={styles.modalFooter}>
                            <button style={styles.button} onClick={this.closeModal}>Cerrar</button>
                          </div>
                        </div>
                      </div>
                    )}

                    <br /><br />
                    <p style={{ fontWeight: "bold", color: "red", fontSize: "12px" }}>Eliminar registro por OT</p>
                    <div className="d-flex align-items-center" style={{ gap: 8, marginTop: 12 }}>
                      <input
                        type="text" placeholder="OT a eliminar..." style={{ maxWidth: 220 }}
                        value={this.state.otEliminar}
                        onChange={(e) => this.setState({ otEliminar: e.target.value })}
                        onKeyDown={(e) => { if (e.key === "Enter") this.handleEliminarOT(); }}
                      />
                      <button className="btn btn-danger" onClick={this.handleEliminarOT}>Eliminar OT</button>
                    </div>
                  </>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Calculo_Resistencias;
